module.exports = "<div nv-compile-once=\"{{ ::questionTemplate.rubric }}\"></div>";